export const servicePackages = [
  {
    name: "Website Design & Development",
    shortTitle: "Web Development",
    description:
      "Custom business websites, landing pages, and scalable web platforms built for performance, usability, and secure deployment.",
    price: "Starting from AED 3,500",
    deliveryTimeline: "10-15 business days",
    refundPolicy:
      "Eligible for partial refund only if canceled before design approval and development kickoff.",
    subscription: "One-time project fee with optional monthly maintenance from AED 450.",
    features: ["Responsive UI", "CMS or custom build", "Basic SEO setup"],
    color: "blue",
  },
  {
    name: "Mobile App Development",
    shortTitle: "Mobile Apps",
    description:
      "Native-feel iOS and Android applications for customer engagement, internal workflows, and digital products.",
    price: "Starting from AED 8,500",
    deliveryTimeline: "4-8 weeks",
    refundPolicy:
      "Discovery and planning fees are non-refundable after approval; milestone refunds depend on completed work.",
    subscription: "Project-based pricing with post-launch support retainers from AED 750 per month.",
    features: ["iOS and Android", "API integration", "App store support"],
    color: "indigo",
  },
  {
    name: "Cloud Infrastructure & DevOps",
    shortTitle: "Cloud & DevOps",
    description:
      "Secure cloud setup, CI/CD automation, deployment workflows, and operational improvements for modern teams.",
    price: "Starting from AED 2,800",
    deliveryTimeline: "7-12 business days",
    refundPolicy:
      "Refunds may be considered before provisioning begins; completed setup and implementation work is non-refundable.",
    subscription: "Monthly managed infrastructure support from AED 1,200.",
    features: ["AWS / Azure / GCP", "CI/CD pipelines", "Monitoring and backups"],
    color: "cyan",
  },
  {
    name: "Cybersecurity Assessment",
    shortTitle: "Cybersecurity",
    description:
      "Security reviews, penetration testing coordination, and risk-based hardening recommendations for web systems.",
    price: "Starting from AED 4,200",
    deliveryTimeline: "5-10 business days",
    refundPolicy:
      "Non-refundable once assessment work, scanning, or reporting activities have started.",
    subscription: "Optional recurring security monitoring packages from AED 950 per month.",
    features: ["Risk review", "Basic vulnerability audit", "Remediation guidance"],
    color: "red",
  },
  {
    name: "AI Automation Solutions",
    shortTitle: "AI & Automation",
    description:
      "Workflow automation, chatbot deployment, and AI-assisted business tooling tailored to operational use cases.",
    price: "Starting from AED 3,900",
    deliveryTimeline: "10-20 business days",
    refundPolicy:
      "Refund eligibility depends on project stage; custom model workflows and completed integrations are generally non-refundable.",
    subscription: "Managed optimization and support plans from AED 1,100 per month.",
    features: ["Chatbot setup", "Process automation", "Reporting workflows"],
    color: "violet",
  },
  {
    name: "Database Management & Optimization",
    shortTitle: "Database Management",
    description:
      "Database architecture, optimization, maintenance, and recovery planning for business-critical applications.",
    price: "Starting from AED 2,200",
    deliveryTimeline: "5-8 business days",
    refundPolicy:
      "Refunds are only available before optimization work or migration activity begins.",
    subscription: "Ongoing database administration packages from AED 850 per month.",
    features: ["Performance tuning", "Backup strategy", "Recovery planning"],
    color: "emerald",
  },
];

export const pricingComplianceNotes = [
  "All prices are quoted in AED.",
  "VAT or other applicable UAE taxes and bank or gateway charges, if any, will be shown before payment confirmation.",
  "Refund eligibility depends on the service type, delivery stage, and approved cancellation status.",
  "Custom quotations may be issued for enterprise scope, integrations, and urgent delivery timelines.",
];
